const papersDataEdexcelInternationalAlevel = {
  mathematics: [
    {
      year: '2025',
      papers: [
        {
          label: 'F1',
          link: 'https://drive.proton.me/urls/WWVRJJG5RM#xecT4xDGGmj8',
          marking: 'https://drive.proton.me/urls/RAKM4WN9MW#zLzcNFppG7pl',
        },
        {
          label: 'F2',
          link: 'https://drive.proton.me/urls/Y11MS2050W#MSdXdbLnv2d7',
          marking: 'https://drive.proton.me/urls/4HD52K1DE0#yPNsO0WRdNhU',
        },
        {
          label: 'F3',
          link: 'https://drive.proton.me/urls/0B42CJXW9C#JrLviboa8SHr',
          marking: 'https://drive.proton.me/urls/6Q6XMF4Z4W#de2PW4DG6dsi',
        },
        {
          label: 'M1',
          link: 'https://drive.proton.me/urls/6X6WEFKPC4#QyT9JugIefb2',
          marking: 'https://drive.proton.me/urls/83JB4HA9KW#7JU6E4qZpU0w',
        },
        {
          label: 'M2',
          link: 'https://drive.proton.me/urls/VYNAR1VS54#wZVQyRFreu0e',
          marking: 'https://drive.proton.me/urls/4HKXHGY1M8#wN3spBsn0ihW',
        },
        {
          label: 'M3',
          link: 'https://drive.proton.me/urls/NQ7TS8TFKC#itqyH0eNnj6y',
          marking: 'https://drive.proton.me/urls/M676H6PSKC#9p9SmVcpQIpW',
        },
        {
          label: 'S1',
          link: 'https://drive.proton.me/urls/K5KW8MGZAM#ojL2QVM4jYg7',
          marking: 'https://drive.proton.me/urls/XD8YX7VPDG#nUbpQjnXmEwQ',
        },
        {
          label: 'S2',
          link: 'https://drive.proton.me/urls/RW7BF1XBB0#6GPbusrFO2Au',
          marking: 'https://drive.proton.me/urls/EJBB6ZASJC#XZFgGOvZOaAy',
        },
        {
          label: 'S3',
          link: 'https://drive.proton.me/urls/CHR9QFKR44#zm2Njk7QoVws',
          marking: 'https://drive.proton.me/urls/48C36FSWPR#0Rqe2tPnMJ0k',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'F1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm01-01-que-20240524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm01-01-rms-20240815.pdf',
        },
        {
          label: 'F2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm02-01-que-20240605.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm02-01-rms-20240815.pdf',
        },
        {
          label: 'F3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm03-01-que-20240612.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm03-01-rms-20240815.pdf',
        },
        {
          label: 'M1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme01-01-que-20240508.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme01-01-rms-20240815.pdf',
        },
        {
          label: 'M2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme02-01-que-20240601.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme02-01-rms-20240815.pdf',
        },
        {
          label: 'M3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme03-01-que-20240613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme03-01-rms-20240815.pdf',
        },
        {
          label: 'S1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst01-01-que-20240522.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst01-01-rms-20240815.pdf',
        },
        {
          label: 'S2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst02-01-que-20240608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst02-01-rms-20240815.pdf',
        },
        {
          label: 'S3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst03-01-que-20240614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst03-01-rms-20240815.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'F1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm01-01-que-20230531.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm01-01-rms-20230817.pdf',
        },
        {
          label: 'F2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm02-01-que-20230609.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm02-01-rms-20230817.pdf',
        },
        {
          label: 'F3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm03-01-que-20230616.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm03-01-rms-20230817.pdf',
        },
        {
          label: 'M1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme01-01-que-20230517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme01-01-rms-20230817.pdf',
        },
        {
          label: 'M2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme02-01-que-20230526.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme02-01-rms-20230817.pdf',
        },
        {
          label: 'M3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme03-01-que-20230607.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme03-01-rms-20230817.pdf',
        },
        {
          label: 'S1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst01-01-que-20230512.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst01-01-rms-20230817.pdf',
        },
        {
          label: 'S2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst02-01-que-20230524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst02-01-rms-20230817.pdf',
        },
        {
          label: 'S3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst03-01-que-20230614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst03-01-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'F1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm01-01-que-20220524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm01-01-rms-20220818.pdf',
        },
        {
          label: 'F2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm02-01-que-20220608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm02-01-rms-20220818.pdf',
        },
        {
          label: 'F3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm03-01-que-20220615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm03-01-rms-20220818.pdf',
        },
        {
          label: 'M1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme01-01-que-20220511.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme01-01-rms-20220818.pdf',
        },
        {
          label: 'M2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme02-01-que-20220517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme02-01-rms-20220818.pdf',
        },
        {
          label: 'M3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme03-01-que-20220531.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme03-01-rms-20220818.pdf',
        },
        {
          label: 'S1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst01-01-que-20220526.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst01-01-rms-20220818.pdf',
        },
        {
          label: 'S2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst02-01-que-20220601.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst02-01-rms-20220818.pdf',
        },
        {
          label: 'S3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst03-01-que-20220611.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst03-01-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'F1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm01-01-que-20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM01_01_rms_20210604.pdf',
        },
        {
          label: 'F2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM02_01_que_20210427.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM02_01_rms_20210604.pdf',
        },
        {
          label: 'F3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM03_01_que_20210507.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM03_01_rms_20210604.pdf',
        },
        {
          label: 'M1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME01_01_que_20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME01_01_msc_20210517.pdf',
        },
        {
          label: 'M2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME02_01_que_20210422.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME02_01_rms_20210604.pdf',
        },
        {
          label: 'M3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME03_01_que_20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME03_01_rms_20210604.pdf',
        },
        {
          label: 'S1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST01_01_que_20210427.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST01_01_rms_20210604.pdf',
        },
        {
          label: 'S2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST02_01_que_20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst02-01-rms-20210604.pdf',
        },
        {
          label: 'S3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst03-01-que-20210507.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst03-01-rms-20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'F1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM01_01_que_20201022.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm01-01-msc-202010113.pdf',
        },
        {
          label: 'F2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM02_01_que_20201010.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM02_01_msc_20210113.pdf',
        },
        {
          label: 'F3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm03-01-que-20201016.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM03_01_msc_202010113.pdf',
        },
        {
          label: 'M1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme01-01-que-20201017.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME01_01_msc_20210113.pdf',
        },
        {
          label: 'M2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME02_01_que_20201021.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME02_01_msc_20210113.pdf',
        },
        {
          label: 'M3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME03_01_que_20201014.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme03-01-msc-20210113.pdf',
        },
        {
          label: 'S1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst01-01-que-20201023.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst01-01-msc-20210113.pdf',
        },
        {
          label: 'S2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST02_01_que_20201015.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST02_01_msc_20210113.pdf',
        },
        {
          label: 'S3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst03-01-que-20201013.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST03_01_msc_20210113.pdf',
        },
      ],
    },
  ],
  biology: [
    {
      year: '2025',
      papers: [
        {
          label: 'Unit 1',
          link: 'https://drive.proton.me/urls/CZTHMA0AHG#WvW31MJaFOt0',
          marking: 'https://drive.proton.me/urls/W6VSK7Y86C#YC3KdxBx4S3L',
        },
        {
          label: 'Unit 2',
          link: 'https://drive.proton.me/urls/CX64C0N52W#tQje7DtVsPKe',
          marking: 'https://drive.proton.me/urls/8BDXTS5CXR#9qr3KxQwX3B7',
        },
        {
          label: 'Unit 3',
          link: 'https://drive.proton.me/urls/23C91R0GD8#ffGULRP4mygC',
          marking: 'https://drive.proton.me/urls/54M4BMXGHR#zARQE1dTvpsy',
        },
        {
          label: 'Unit 4',
          link: 'https://drive.proton.me/urls/F93HCPYSMC#Pymld0dZ5lVa',
          marking: 'https://drive.proton.me/urls/GWY6S45DTC#YBlF9BhYSGAc',
        },
        {
          label: 'Unit 5',
          link: 'https://drive.proton.me/urls/59BXGEYYSM#2KyJy8X0wEfW',
          marking: 'https://drive.proton.me/urls/2SAARAQEYG#H0lmVPBOP1MD',
        },
        {
          label: 'Unit 6',
          link: 'https://drive.proton.me/urls/0TXS90E778#VfeC0nHptnT6',
          marking: 'https://drive.proton.me/urls/9AJ14EH59C#U7OjbIVXEyj9',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi11-01-que-20240508.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi11-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi12-01-que-20240518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi12-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi13-01-que-20240523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi13-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi14-01-que-20240529.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi14-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi15-01-que-20240608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi15-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi16-01-que-20240613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi16-01-rms-20240815.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi11-01-que-20230509.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi11-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi12-01-que-20230520.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi12-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi13-01-que-20230525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi13-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi14-01-que-20230602.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi14-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi15-01-que-20230606.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi15-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi16-01-que-20230617.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi16-01-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi11-01-que-20220510.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi11-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi12-01-que-20220518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi12-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi13-01-que-20220526.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi13-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi14-01-que-20220528.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi14-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi15-01-que-20220609.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi15-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi16-01-que-20220617.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi16-01-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI11_01_que_20210421.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI11_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI12_01_que_20210505.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI12_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI13_01_que_20210506.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI13_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI14_01_que_20210419.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI14_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI14_01_que_20210419.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI15_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI16_01_que_20210505.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI16_01_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI11_01_que_20201006.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI11_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI12_01_que_20201009.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI12_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI13_01_que_20201014.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI13_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI14_01_que_20201017.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI14_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI15_01_que_20201022.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI15_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI16_01_que_20201027.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI16_01_msc_20210113.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI11_01_que_20190522.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi11-01-rms-20190815.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI12_01_que_20190525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI12_01_rms_20190822.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI13_01_que_20190507.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI13_01_rms_20190815.pdf',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2025',
      papers: [
        {
          label: 'Unit 1',
          link: 'https://drive.proton.me/urls/SMAMZ4QKT0#jx9mURdjR28t',
          marking: 'https://drive.proton.me/urls/NA1GCEN9T4#WFHzsrbrYk4X',
        },
        {
          label: 'Unit 2',
          link: 'https://drive.proton.me/urls/BDE0B6SESG#TGOKMHAg4zIx',
          marking: 'https://drive.proton.me/urls/R0SFV8VTE8#8jStjIicc43x',
        },
        {
          label: 'Unit 3',
          link: 'https://drive.proton.me/urls/D2RWM3A73M#ezh2pUTEhfbM',
          marking: 'https://drive.proton.me/urls/DBKWGZAE9R#CGcOKB98nwS3',
        },
        {
          label: 'Unit 4',
          link: 'https://drive.proton.me/urls/G8NZ1NVKKG#Am1CiMYb2Vpg',
          marking: 'https://drive.proton.me/urls/SZ0N2AMPK8#z9bjY3teM8L8',
        },
        {
          label: 'Unit 5',
          link: 'https://drive.proton.me/urls/W647PR8BRC#NZ1uQx0Om0zl',
          marking: 'https://drive.proton.me/urls/2AFJBJW6V8#qMf4mIFOjSev',
        },
        {
          label: 'Unit 6',
          link: 'https://drive.proton.me/urls/GWXAABW4EM#LOXjtMzXTwqW',
          marking: 'https://drive.proton.me/urls/HVFWRX8WDC#gap3I8WBeJVi',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch11-01-que-20240509.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch11-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch12-01-que-20240702.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch12-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch13-01-que-20240525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch13-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch14-01-que-20240530.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch14-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch15-01-que-20240604.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch15-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch16-01-que-20240615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch16-01-rms-20240815.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch11-01-que-20230511.pdf',
          marking: 'N/A',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch12-01-que-20230516.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch12-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch13-01-que-20230527.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch13-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch14-01-que-20230603.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch14-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch15-01-que-20230608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch15-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch16-01-que-20230613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Chemistry/2018/Exam-materials/wch16-01-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch11-01-que-20220511.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch11-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch12-01-que-20220519.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch12-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch13-01-que-20220524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch13-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch14-01-que-20220602.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch14-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch15-01-que-20220610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch15-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch16-01-que-20220615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch16-01-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH11_01_que_20210420.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH11_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH12_01_que_20210426.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH12_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH13_01_que_20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH13_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH14_01_que_20210421.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH14_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH15_01_que_20210428.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH15_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH16_01_que_20210505.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH16_01_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH11_01_que_20201007.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH11_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH12_01_que_20201010.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH12_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH13_01_que_20201015.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH13_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH14_01_que_20201020.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH14_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH15_01_que_20201023.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH15_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH16_01_que_20201028.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH16_01_msc_20210113.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH11_01_que_20190521.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH11_01_rms_20190815.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH12_01_que_20190524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH12_01_rms_20190815.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH13_01_que_20190508.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH13_01_rms_20190815.pdf',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2025',
      papers: [
        {
          label: 'Unit 1',
          link: 'https://drive.proton.me/urls/NA71Z33HDM#J7LTJ6UUagcn',
          marking: 'https://drive.proton.me/urls/ZN715638W8#RUtD6LDiCKJd',
        },
        {
          label: 'Unit 2',
          link: 'https://drive.proton.me/urls/1G1G38YWJ0#JoOknvNIbuRN',
          marking: 'https://drive.proton.me/urls/07K9XSQE2R#VyOV9utH28mL',
        },
        {
          label: 'Unit 3',
          link: 'https://drive.proton.me/urls/0276XN5W9W#NesLJDLX1vtR',
          marking: 'https://drive.proton.me/urls/19PHNPG67R#7UTzqKLKpbfx',
        },
        {
          label: 'Unit 4',
          link: 'https://drive.proton.me/urls/ZR088WWTA0#iellS25uZjbe',
          marking: 'https://drive.proton.me/urls/0WYYB53TP4#R4OgzQz9ZVeb',
        },
        {
          label: 'Unit 5',
          link: 'https://drive.proton.me/urls/8M503GVKYR#Y8hHE1g5LA4u',
          marking: 'https://drive.proton.me/urls/GDZMJ72DT4#HYRZ6io2bXdp',
        },
        {
          label: 'Unit 6',
          link: 'https://drive.proton.me/urls/72A7F27154#wQinrYrYxmPb',
          marking: 'https://drive.proton.me/urls/JK966B4Y8C#LkyC4Xk5nov9',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph11-01-que-20240511.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph11-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph12-01-que-20240516.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph12-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph13-01-que-20240521.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph13-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph14-01-que-20240601.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph14-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph15-01-que-20240606.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph15-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph16-01-que-20240611.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph16-01-rms-20240815.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph11-01-que-20230513.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph11-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph12-01-que-20230518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph12-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph13-01-que-20230523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph13-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph14-01-que-20230531.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph14-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph15-01-que-20230610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph15-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph16-01-que-20230615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Physics/2018/Exam-materials/wph16-01-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph11-01-que-20220512.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph11-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph12-01-que-20220517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph12-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph13-01-que-20220525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph13-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph14-01-que-20220601.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph14-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph15-01-que-20220608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph15-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph16-01-que-20220616.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph16-01-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH11_01_que_20210429.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH11_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH12_01_que_20210429.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH12_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH13_01_que_20210511.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH13_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH14_01_que_20210428.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH14_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH15_01_que_20210429.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH15_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH16_01_que_20210511.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH16_01_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH11_01_que_20201008.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH11_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH12_01_que_20201013.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH12_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH13_01_que_20201016.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH13_01__msc_20210113.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH14_01_que_20201021.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH14_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH15_01_que_20201024.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH15_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH16_01_que_20201029.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH16_01_msc_20210113.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH11_01_que_20190515.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/wph11-01-rms-20190815.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH12_01_que_20190518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH12_01_rms_20190815.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH13_01_que_20190509.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Physics/2018/Exam-materials/WPH13_01_rms_20190815.pdf',
        },
      ],
    },
  ],
  economics: [
    {
      year: '2025',
      papers: [
        {
          label: 'Unit 1',
          link: 'https://drive.proton.me/urls/63MYH9VPPC#n2BxFDscygsi',
          marking: 'https://drive.proton.me/urls/5K0VJVSGBG#q9mTp4VqlnFK',
        },
        {
          label: 'Unit 2',
          link: 'https://drive.proton.me/urls/2CY02C3A88#ROneIu1uFJAz',
          marking: 'https://drive.proton.me/urls/H1SMEJBMS4#yrub0IDHgT7r',
        },
        {
          label: 'Unit 3',
          link: 'https://drive.proton.me/urls/B7M6HFT9T0#IrtKV9cRl1fu',
          marking: 'https://drive.proton.me/urls/XA8S8DC86M#eFF6NMB4S11b',
        },
        {
          label: 'Unit 4',
          link: 'https://drive.proton.me/urls/65JVE5E818#vAWgBGh05Jg3',
          marking: 'https://drive.proton.me/urls/80DHHYGQKR#10uzPigMRboX',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec11-01-que-20240510.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec11-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec12-01-que-20240516.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec12-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec13-01-que-20240529.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec13-01-rms-20240815.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec14-01-que-20240605.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec14-01-rms-20240815.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec11-01-que-20230510.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec11-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec12-01-que-20230516.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec12-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec13-01-que-20230602.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec13-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec14-01-que-20230614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Economics/2018/Exam-materials/wec14-01-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/wec11-01-que-20220512.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/wec11-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/wec12-01-que-20220520.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/wec12-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/wec13-01-que-20220601.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/wec13-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/wec14-01-que-20220610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/wec14-01-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC11_01_que_20210426.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC11_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC12_01_que_20210429.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC12_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC13_01_que_20210429.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC13_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC14_01_que_20210504.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC14_01_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC11_01_que_20201016.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC11_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC12_01_que_20201021.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC12_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC13_01_que_20201007.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC13_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC14_01_que_20201013.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC14_01_msc_20210113.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC11_01_que_20190514.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC11_01_rms_20190815.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC12_01_que_20190517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Economics/2018/Exam-materials/WEC12_01_rms_20190815.pdf',
        },
      ],
    },
  ],
};

export default papersDataEdexcelInternationalAlevel;
